import React, { useMemo } from "react";
import { JerseyModeEnum } from "../../../client/api";
import {
  JERSEY_VIEWBOX,
  JerseyCheckeredPattern,
  JerseyHorizontalPattern,
  JerseyLeftPath,
  JerseyOutlinePath,
  JerseyRightPath,
  JerseySleevePattern,
  JerseyVerticalPattern
} from "../../../assets/svg/jerseyPaths";

interface JerseyProps {
  color1: string;
  color2: string;
  mode: JerseyModeEnum;
  width: number;
  className?: string;
}

const JerseySvg: React.FC<JerseyProps> = React.memo(({ mode, width, color1, color2, className }) => (
  <svg 
    viewBox={JERSEY_VIEWBOX}
    width={width} 
    height={width}
    className={className}
  >
    <JerseyLeftPath
      fill={mode === JerseyModeEnum.SLEEVE ? color2 : color1}
      stroke={color1}
    />
    <JerseyRightPath
      fill={mode === JerseyModeEnum.DUO || mode === JerseyModeEnum.SLEEVE ? color2 : color1}
      stroke={color1}
    />
    {mode === JerseyModeEnum.HORIZONTAL_STRIPE ? (
      <JerseyHorizontalPattern fill={color2} />
    ) : mode === JerseyModeEnum.VERTICAL_STRIPE ? (
      <JerseyVerticalPattern fill={color2} />
    ) : mode === JerseyModeEnum.CHECKERED ? (
      <JerseyCheckeredPattern fill={color2} />
    ) : mode === JerseyModeEnum.SLEEVE ? (
      <JerseySleevePattern fill={color1} />
    ) : null}
    <JerseyOutlinePath />
  </svg>
));

const Jersey: React.FC<{
  color1: string;
  color2: string;
  mode: JerseyModeEnum;
  size: 'xs' | 'small' | 'lineup' | 'normal' | 'large' | number;
  className?: string;
}> = ({ color1, size, color2, mode, className }) => {
  const width = useMemo(() => {
    if (typeof size === 'number') {
      return size;
    }
    return (
      size === 'xs'
        ? 24
        : size === 'small'
        ? 32
        : size === 'lineup'
        ? 64
        : size === 'normal'
        ? 96
        : 128
    );
  }, [size]);

  return (
    <JerseySvg
      mode={mode}
      color1={color1}
      color2={color2}
      width={width}
      className={className}
    />
  );
};

Jersey.displayName = 'Jersey';
JerseySvg.displayName = 'JerseySvg';

export default Jersey;